// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider2_root__1yrEy","label":"Slider2_label__2GTkP","labelSpacing":"Slider2_labelSpacing__-hUQr","tp":"Slider2_tp__BAZfN","main":"Slider2_main__1H0zf"};